import type { Route } from '@atlassian/react-resource-router';
import { useLastLoadedRoute } from '../store/index.tsx';

export const useRouteEntryPoint = ({ route }: { route: Route }) => {
	const [lastLoadedRoute] = useLastLoadedRoute();

	// route.entryPoint is already loaded
	if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) {
		return lastLoadedRoute.entryPointReference;
	}

	return null;
};
